"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import styles from "./ProductSpecificationAccordion.module.scss";
import { Attribute } from "../../../../types/prodcatBaseTypes";

type Props = {
  attributes: Attribute[];
  productType: string;
  open?: boolean;
};

export function ProductSpecificationAccordionUI({
  attributes,
  productType,
  open,
}: Props) {
  if (productType === "RetiredStaticBundle") return null;

  return (
    <Accordion
      className={styles["product-accordion__item"]}
      data-testid="accordion:specification"
      label="Product specification"
      animated={true}
      responsive
      open={open}
    >
      <dl
        data-testid="product:specification:list"
        className={styles.productSpecificationList}
      >
        {attributes.map((attribute, index) => (
          <ProductAttribute key={`attribute-${index}`} attribute={attribute} />
        ))}
      </dl>
    </Accordion>
  );
}

function ProductAttribute({ attribute }: { attribute: Attribute }) {
  return (
    <div className={styles.productSpecificationListItem}>
      <dd
        key={`${attribute.key}-label`}
        data-testid="product:specification:list:label"
        className={styles.productSpecificationListLabel}
      >
        <span className={styles.productSpecificationListLabelName}>
          {attribute.displayName}
        </span>
        {attribute.helpText && (
          <ProductAttributeToolTip
            helpText={attribute.helpText}
            toolTipId={attribute.key}
          />
        )}
      </dd>
      <dt
        key={`${attribute.key}-value`}
        data-testid="product:specification:list:value"
        className={styles.productSpecificationListValue}
      >
        {attribute.values?.join(", ")}
      </dt>
    </div>
  );
}

function ProductAttributeToolTip({
  helpText,
  toolTipId,
}: {
  helpText: string;
  toolTipId: string;
}) {
  return (
    <div
      data-testid="product:specification:list:label:tooltip"
      className={styles.productSpecificationListLabelToolTip}
    >
      <div className={styles.tooltipWrapper}>
        <Tooltip
          id={`tooltip-${toolTipId}`}
          icon
          anchor="right"
          verticalAnchor="top"
        >
          {helpText}
        </Tooltip>
      </div>
    </div>
  );
}
